export const BUSINESS = {
  name: "Uma Enterprises",
  phoneDisplay: "+91 89220 04004",
  phoneIntl: "+918922004004",
  email: "enterprises.uma08@gmail.com",
  gstin: "09AHTPU9413H1ZJ",
  address: "444/177 Mallahi Tola, 2nd Barafkhana, Lucknow, U.P. 226003",
  mapQuery: "444/177 Mallahi Tola, Baraafkhana, Lucknow, Uttar Pradesh 226003",
  hours: "Mon – Sat · 10:00 AM – 7:00 PM",
};
